export default "__VITE_ASSET__9085ebe6__"